import { render, staticRenderFns } from "./AtmFooter.vue?vue&type=template&id=05842743&"
import script from "./AtmFooter.vue?vue&type=script&lang=js&"
export * from "./AtmFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05842743')) {
      api.createRecord('05842743', component.options)
    } else {
      api.reload('05842743', component.options)
    }
    module.hot.accept("./AtmFooter.vue?vue&type=template&id=05842743&", function () {
      api.rerender('05842743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/AtmFooter.vue"
export default component.exports